import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../service/auth.service';
import { AlertService } from 'src/app/shared/service/alert.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: []
})
export class ResetPasswordComponent implements OnInit {

  resetForm: FormGroup;
  submitted = false;
  showCodeAndPassword = false;

  constructor(
    private router: Router,
    private authService: AuthService,
    private alertService: AlertService,
    private fb: FormBuilder
  ) {
    this.resetForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      code: [''],
      password: [''],
      confirmPassword: ['']
    });
  }

  ngOnInit(): void {
    // Eliminado el error anterior
  }

  get f() {
    return this.resetForm.controls as {
      email: AbstractControl;
      code: AbstractControl;
      password: AbstractControl;
      confirmPassword: AbstractControl;
    };
  }

  sendCode() {
    this.submitted = true;
    if (this.f.email.invalid) return;

    const email = this.f.email.value;
    this.authService.requestResetPassword(email).subscribe(() => {
      this.alertService.showSuccessful(
        `
    <p style="margin: 0; font-size: 16px;">
      Te hemos enviado un <strong>código de verificación</strong> a tu correo electrónico.
    </p>
    <p style="margin: 10px 0 0; font-size: 14px; color: #555;">
      Este código tiene una validez de <strong>10 minutos</strong>. Por favor, revísalo y continúa con el proceso.
    </p>
  `,
        '¡Código enviado con éxito!'
      );
      // Aquí enviarías el código por correo desde el backend
      console.log('Código enviado a:', this.f.email.value);

      this.showCodeAndPassword = true;
      this.submitted = false;

      // Opcional: limpiar validador de email si ya se envió
      this.f.email.clearValidators();
      this.f.email.updateValueAndValidity();

      // Activar validación de código y contraseñas
      this.f.code.setValidators([Validators.required, Validators.minLength(6)]);
      this.f.password.setValidators([Validators.required, Validators.minLength(4)]);
      this.f.confirmPassword.setValidators([Validators.required]);

      this.f.code.updateValueAndValidity();
      this.f.password.updateValueAndValidity();
      this.f.confirmPassword.updateValueAndValidity();
    });

  }



  onSubmit() {
    this.submitted = true;

    if (this.resetForm.invalid) {
      return;
    }

    if (this.f.password.value !== this.f.confirmPassword.value) {
      this.alertService.showWarning(
        `
    <p style="margin: 0; font-size: 16px;">
      Las contraseñas que ingresaste <strong>no coinciden</strong>.
    </p>
    <p style="margin: 10px 0 0; font-size: 14px; color: #555;">
      Por favor, verifica que ambas contraseñas sean iguales e intenta nuevamente.
    </p>
  `,
        'Contraseñas no coinciden'
      );

      return;
    }
    const obj = {}
    obj['email'] = this.f.email.value;
    obj['code'] = this.f.code.value;
    obj['password'] = this.f.password.value;
    this.authService.resetPassword(obj).subscribe(() => {
      this.alertService.showSuccessful('Se ha actualizado la contraseña correctamente', 'Actualizado exito!').then(() => {
        this.router.navigate(['/login']);
      });
    })


  }
}
